import styled from "styled-components";

export const Container = styled.div`
    text-align: center;
    margin: 10px;
`